import React, { useEffect, useMemo, useState } from 'react';
import { EFormSectionStatus, IFormSectionProps } from './types';
import { FillingIcon } from 'assets/icons/filling';
import { ToBeFilledIcon } from 'assets/icons/to-be-filled';
import { FilledIcon } from 'assets/icons/filled';
import { ArrowRightIcon } from 'assets/icons/arrow-right';
import { cn } from 'utils';

const FormSection: React.FC<IFormSectionProps> = ({
  title,
  children,
  status,
  collapsible,
}) => {
  const [isCollapsed, setIsCollapsed] = useState(
    EFormSectionStatus.FILLING !== status
  );

  useEffect(() => {
    if (status !== EFormSectionStatus.TO_BE_FILLED) {
      setIsCollapsed(false);
    }
  }, [status]);

  const formSectionPrefixIcon = useMemo(() => {
    if (status === EFormSectionStatus.FILLED) {
      return <FilledIcon />;
    } else if (status === EFormSectionStatus.TO_BE_FILLED) {
      return <ToBeFilledIcon />;
    } else if (status === EFormSectionStatus.FILLING) {
      return <FillingIcon />;
    }

    return null;
  }, [status]);

  return (
    <div className="bg-white rounded-lg mb-4 overflow-hidden shadow-[0px_4px_24px_rgba(0,_0,_0,_0.08)] border">
      <div
        className={cn(
          'flex justify-between items-center bg-[#F8F8F8] p-4',
          collapsible && 'cursor-pointer'
        )}
        onClick={() => {
          if (collapsible && status !== EFormSectionStatus.TO_BE_FILLED) {
            setIsCollapsed((prev) => !prev);
          }
        }}
      >
        <h2 className="text-[#010D1D] text-lg flex gap-2 items-center font-medium">
          {formSectionPrefixIcon}
          {title}
        </h2>
        {collapsible && (
          <div
            className={`transition-transform duration-300 ${isCollapsed ? '' : 'rotate-90'}`}
          >
            <ArrowRightIcon />
          </div>
        )}
      </div>

      <div
        className={cn(
          'transition-all duration-300 ease-in-out origin-top',
          isCollapsed && collapsible ? 'h-0 opacity-0' : 'opacity-100'
        )}
      >
        <div className="px-4 py-4">{children}</div>
      </div>
    </div>
  );
};

export default FormSection;
